module.exports = __webpack_public_path__ + "static/media/view1.589a289b.jpg";